
<template lang="pug">
  button.button(
    type="button", 
    ref="button",
    :class="buttonClass",
    :disabled="disabled",
    @click.stop="$emit('click')"
  )
    icon(v-if="icon", :name="icon", :size="iconSize" :confirmation="confirmation")
    span {{ label }}
    span(v-if="count" class="count") {{ count }}
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue'

  export default {
    name: 'PrimaryButton',
    components: { Icon },
    props: {
      label: String,
      icon: String,
      size: String,
      classes: {
        type: String,
        defalt: ''
      },
      small: {
        type: Boolean,
        default: false
      },
      full: {
        type: Boolean,
        default: false
      },
      hollow: {
        type: Boolean,
        default: false
      },
      secondary: {
        type: Boolean,
        default: false
      },
      tertiary: {
        type: Boolean,
        default: false
      },
      wide: {
        type: Boolean,
        deafult: false
      },
      text: {
        type: Boolean,
        default: false
      },
      flex: {
        type: Boolean,
        default: false
      },
      inline: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      confirmation: {
        type: Boolean,
        default: false
      },
      count: Number,
    },
    computed: {
      buttonClass () {
        return {
          'button--primary': this.secondary === false,
          'button--secondary': this.secondary === true,
          'button--tertiary': this.tertiary === true,
          'button--hollow': this.hollow === true,
          'button--small': this.small === true,
          'button--full': this.full === true,
          'button--text': this.text === true,
          'button--flex': this.flex === true,
          'button--inline': this.inline === true,
          'button--confirmation': this.confirmation === true,
          'button--count': this.count > 0
        }
      },
      iconSize () {
        if(this.size) return this.size;
        return (this.small) ? '12px' : '24px'
      }
    }
  }
</script>

<style scoped lang="scss">
</style>
